<script lang="ts">
  // components
  import ConnectDistributorModal from "@retailer/svelte/Settings/DistributorContacts/ConnectDistributorModal/ConnectDistributorModal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // services
  import AddRepModalService from "@shared/svelte/Modules/AddRepModalService";
  import { restrictRepAccess } from "@retailer/services/preview_forbidden_flash";

  // stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { Distributor } from "@shared/types/Distributor";

  export let selectedDistributor: Distributor = null;

  const service = new AddRepModalService();

  let showConnectDistributorModal = false;
  let selectedReps = [];

  const submit = service.submit();

  const openConnectDistributorModal = (): void => {
    if (restrictRepAccess()) return;

    showConnectDistributorModal = true;
  };

  $: if (!showConnectDistributorModal) {
    selectedReps = [];
  }
</script>

<div
  class="fizz-flex-row-4 fizz-align-content-start fizz-text-subdued fizz-text-small"
  class:fizz-stack-16={$layoutStore.isMobile}
  class:fizz-stack-4={$layoutStore.isDesktop}
>
  <Icon type="Lock" extraClassNames="fizz-icon-16" />
  <p
    >Looking for inventory?
    <a
      href={"#"}
      class="fizz-text-inherit fizz-text-underline"
      data-testid="connect-account-button"
      on:click|preventDefault={openConnectDistributorModal}
    >
      Connect Account
    </a>
  </p>
</div>
<ConnectDistributorModal
  {submit}
  bind:showConnectDistributorModal
  bind:selectedReps
  {selectedDistributor}
  addNewSalesRep={service.addNewSalesRep}
  providedDistributor={true}
  addSalesRepErrorCallback={service.addSalesRepErrorCallback}
  submitErrorCallback={service.errorCallback}
/>
